import React, { useState, useContext, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { v4 as uuidv4 } from 'uuid';
import UserContext from '../context/UserContext';
import { api } from '../utils/apiHelper';
import '../styles/PopCustom.css';

const PopCustom = () => {
  const { authUser } = useContext(UserContext);
  const userId = authUser._id;

  const [header, setHeader] = useState('Welcome!');
  const [headerStyle, setHeaderStyle] = useState('');
  const [paragraphText, setParagraphText] = useState('');
  const [paragraphStyle, setParagraphStyle] = useState('');
  const [buttonLabel, setButtonLabel] = useState('Join Now');
  const [linkAddress, setLinkAddress] = useState('');  // NEW: link input state
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: { 'image/*': [] },
  });

  const uploadImageToS3 = async (file) => {
    try {
      const fileName = `${uuidv4()}-${file.name}`;
      const fileType = file.type;

      const res = await api('/pop-signed-url', 'POST', {
        fileName,
        fileType,
        userId,
      });

      if (!res.url || !res.key) throw new Error('Missing S3 URL or key');

      const uploadRes = await fetch(res.url, {
        method: 'PUT',
        headers: { 'Content-Type': fileType },
        body: file,
      });

      if (!uploadRes.ok) throw new Error(`Upload failed: ${uploadRes.status}`);

      return res.key;
    } catch (err) {
      console.error('Error uploading image to S3:', err);
      return '';
    }
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      let imageKey = '';

      if (imageFile) {
        imageKey = await uploadImageToS3(imageFile);
      }

      await api('/submit-popup-config', 'POST', {
        userId,
        header,
        headerStyle,
        paragraph: {
          text: paragraphText,
          style: paragraphStyle,
        },
        buttonLabel,
        linkAddress,  
        imageKey,
      });

      alert('Saved successfully!');
    } catch (err) {
      console.error('Error submitting popup config:', err);
      alert('Something went wrong.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="popup-config-container">
      <h2>Edit Welcome Popup</h2>

      <label>Header Text</label>
      <input
        type="text"
        value={header}
        onChange={(e) => setHeader(e.target.value)}
      />

      <label>Header Style</label>
      <input
        type="text"
        placeholder="e.g. color:blue; font-size:28px;"
        value={headerStyle}
        onChange={(e) => setHeaderStyle(e.target.value)}
      />

      <label>Paragraph Text</label>
      <textarea
        placeholder="Enter paragraph text..."
        value={paragraphText}
        onChange={(e) => setParagraphText(e.target.value)}
      />

      <label>Paragraph Style</label>
      <input
        type="text"
        placeholder="e.g. color:gray; font-style:italic;"
        value={paragraphStyle}
        onChange={(e) => setParagraphStyle(e.target.value)}
      />

      <label>Submit Button Text</label>
      <input
        type="text"
        value={buttonLabel}
        onChange={(e) => setButtonLabel(e.target.value)}
      />

      <label>Link Address</label>
      <input
        type="text"
        placeholder=""
        value={linkAddress}
        onChange={(e) => setLinkAddress(e.target.value)}
      />

      <label>Upload Image</label>
      <div {...getRootProps({ className: 'pop-drop' })}>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the image here...</p>
        ) : (
          <p>Drag & drop an image here, or click to select one</p>
        )}
      </div>
      {imagePreview && (
        <img src={imagePreview} alt="Preview" className="preview-thumbnail" />
      )}

      <button onClick={handleSubmit} disabled={submitting}>
        Save Configuration
      </button>
    </div>
  );
};

export default PopCustom;
